import { render, staticRenderFns } from "./sliderChoiceItem.vue?vue&type=template&id=29df7cec"
import script from "./sliderChoiceItem.vue?vue&type=script&lang=js"
export * from "./sliderChoiceItem.vue?vue&type=script&lang=js"
import style0 from "./sliderChoiceItem.vue?vue&type=style&index=0&id=29df7cec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports